import { Empty, Typography } from "antd";
import React, { ReactNode } from "react";

type Props = {
  imgPath: string;
  description: string | ReactNode;
  icon?: React.ReactNode;
};

export const WidgetEmpty = ({
  imgPath,
  description,
  icon = <img src={imgPath} alt="No Data" />,
}: Props) => {
  return (
    <div className="ac-empty-widget d-flex align-items-center justify-content-center h-100">
      <Empty
        description={
          <Typography.Text style={{ color: "#979797" }}>
            {description}
          </Typography.Text>
        }
        image={icon}
      />
    </div>
  );
};
